export const getCookieDomains = () => {
  // An array of cookie domains should be set as a `data-cookie-domains` attribute
  // on the <body> tag in Layouts::AppLayout
  if (document.body.dataset.cookieDomains) {
    return JSON.parse(document.body.dataset.cookieDomains)
  }

  return [window.location.hostname]
}
